import React, { useRef } from 'react';
import { generateUUID } from '@wix/form-schema';
export const useId = typeof React.useId === 'function' ? React.useId : () => useRef(generateUUID()).current;
//# sourceMappingURL=use-id.js.map